import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import MainLayout from '../Layout/MainLayout';
import styles from '../../assets/styles/Setting.module.scss';

const ProjectSettingsLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {

  const location = useLocation();
  const navigate = useNavigate();

  const tabs = [
    { label: '予算設定', path: '/project-setting/budget' },
    { label: '広告設定', path: '/project-setting/preference' },
    { label: '外部連携', path: '/project-setting/external' },
  ];

  const isActive = (path: string) => location.pathname === path;

  const headerContent = (
    <nav className={styles.settingsNav}>
      {tabs.map((tab) => (
        <button
          key={tab.path}
          onClick={() => navigate(tab.path)}
          className={`${styles.tabButton} ${isActive(tab.path) ? styles.active : ''}`}
        >
          {tab.label}
        </button>
      ))}
    </nav>
  );

  return (
    <MainLayout title="プロジェクト設定" headerContent={headerContent}>
      <div className={styles.settingDetail}>
        {children}
      </div>
    </MainLayout>
  );
};

export default ProjectSettingsLayout;
